import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const useGetTrialDocuments = ({ trialId, showDeleted = false, enabled = true }) => {
  const token = localStorage.getItem("token");

  return useQuery({
    queryKey: ["trial-documents", trialId, showDeleted],
    queryFn: async () => {
      const res = await axios.get(`${__API_URL__}/api/photos/trials/${trialId}/documents/`, {
        headers: { Authorization: `Token ${token}` },
        params: { show_deleted: showDeleted },
      });
      return res.data;
    },
    enabled: enabled && Boolean(trialId),
  });
};

export default useGetTrialDocuments;
